import React, {Component} from 'react';
import PropTypes from 'prop-types';



export default class Scroller extends Component {
    render() {
        return <a   role="button"
                    onClick={this._onClickHandler.bind(this)}>{
                        this.props.children
                    }</a>;
    }

    _onClickHandler(e) {
        e.preventDefault();
        const $ = window.$;
        if (this.props.selector && $(this.props.selector).length > 0)
        {
            $('html, body').animate({
                scrollTop: $(this.props.selector).offset().top
            }, this.props.duration);
        }
    }
}

Scroller.defaultProps = {
    selector: "",
    duration: 0
}

Scroller.propTypes = {
    selector: PropTypes.string.isRequired,
    duration: PropTypes.number
}

